(function () {
    'use strict';

    function main() {
        var page = wo$('#phone');
        if (!page.length) return;

        var phoneController = {
            init: function () {
                phoneController.registerNotifications();
                phoneController.initHistoryTracker();
                phoneController.loadSearchModal();
                phoneController.bindByod();
                phoneController.bindPlanSummary();
                WhistleOut.getAds('MobilePhones');

                page.find('[data-gallery]').each(function () {
                    wo$(this).magnificPopup({
                        delegate: 'a[data-gallery-item]',
                        type: 'image',
                        zoom: {
                            enabled: true,
                            duration: 400
                        },
                        gallery: {
                            enabled: true
                        }
                    });
                });

                page.find('a[data-gallery-opener]').click(function () {
                    wo$(this).parents('[data-gallery]').find('a[data-gallery-item]').last().click();
                });

                page.find('#whistleout-review-article img')
                    .one('load', function () {
                        phoneController.fixArticleImage(wo$(this));
                    })
                    .each(function () {
                        if (this.complete) {
                            phoneController.fixArticleImage(wo$(this));
                        }
                    });

                page.find('#also-viewed').change(function () {
                    var phone = wo$(this).val();
                    location.href = phone;
                });
            },

            registerNotifications: function () {
                WhistleOut.notifications.add(function (notification, data) {
                    if (data && data.criteria && data.type !== 'Page') {
                        data.criteria.page = 1;
                    }

                    if (notification === 'FilterChanged') {
                        wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                        var isAjax =
                            data.type === 'Sort' ||
                            data.type === 'Page' ||
                            data.type === 'Data' ||
                            data.type === 'Minutes' ||
                            data.type === 'Calls' ||
                            data.type === 'Messages' ||
                            data.type === 'MaxUpfront' ||
                            data.type === 'PlanSummary' ||
                            data.type === 'FeaturedResults';
                        phoneController.updateFilters(data.criteria, !isAjax);
                    } else if (notification === 'TabChanged') {
                        phoneController.loadSearchModal();
                    } else if (notification === 'SearchResultsRendered') {
                        phoneController.loadSearchModal();
                        wo$(window).resize();
                    }
                });
            },

            bindByod: function () {
                page.find('*[data-show-byo-phone-modal]')
                    .off()
                    .on('click', function () {
                        var source = wo$(this);

                        var manufacturerShortUrl = source.data('brand-short-url');
                        var phoneShortUrl = source.data('phone-short-url');

                        var byoModalContainer = wo$('#byo-modal-container');
                        if (byoModalContainer && byoModalContainer.length > 0) {
                            //ToDo move to shared function
                            WhistleOut.byoPhonePickerController.show(
                                function (selectedModel) {
                                    var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                                    criteria.lines[0].phone = null;
                                    if (selectedModel) {
                                        criteria.lines[0].byoPhoneModelId = selectedModel.selectedModelId;
                                    }
                                    criteria.lines[0].simOnly = true;
                                    WhistleOut.notifications.fire('FilterChanged', {
                                        type: 'Phone',
                                        criteria: criteria
                                    });
                                },
                                manufacturerShortUrl,
                                phoneShortUrl
                            );
                        } else {
                            var siteConfiguration = WhistleOut.getSiteConfiguration();
                            wo$.ajax({
                                url: siteConfiguration.byoPhonePickerModalUrl,
                                type: 'GET',
                                success: function (result) {
                                    if (result !== '') {
                                        if (!byoModalContainer || byoModalContainer.length < 1) {
                                            wo$('body').append('<div id="byo-modal-container"></div>');
                                            byoModalContainer = wo$('#byo-modal-container');
                                        }
                                        byoModalContainer.html(result);
                                        //ToDo move to shared function
                                        WhistleOut.byoPhonePickerController.show(
                                            function (selectedModel) {
                                                var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                                                criteria.lines[0].phone = null;
                                                if (selectedModel) {
                                                    criteria.lines[0].byoPhoneModelId = selectedModel.selectedModelId;
                                                }
                                                criteria.lines[0].simOnly = true;
                                                WhistleOut.notifications.fire('FilterChanged', {
                                                    type: 'Phone',
                                                    criteria: criteria
                                                });
                                            },
                                            manufacturerShortUrl,
                                            phoneShortUrl
                                        );
                                    }
                                }
                            });
                        }
                    });
            },

            loadSearchModal: function () {
                var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                var modalUrl =
                    criteria.lines.length > 1 ? criteria.multiLineModalAjaxUrl : criteria.singleLineModalAjaxUrl;

                var queryString = WhistleOut.MobilePhones.generateQueryString(criteria);
                wo$.ajax({
                    url: modalUrl + '?' + queryString,
                    type: 'GET',
                    success: function (result) {
                        var $results = wo$('#filters-modal-partial');
                        $results.html(result);
                        WhistleOut.notifications.fire('FiltersModalReady');
                    }
                });
            },

            bindPlanSummary: function () {
                page.find('#plan-summary [data-supplier]').click(function () {
                    var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                    //criteria.enforcemaximumresultlimits = false;
                    var supplierShortUrl = wo$(this).data('supplier');
                    if (supplierShortUrl) {
                        criteria.suppliers = [supplierShortUrl];
                    } else {
                        criteria.suppliers = [];
                    }
                    WhistleOut.scrollTo('#search-results-partial');
                    WhistleOut.notifications.fire('FilterChanged', { type: 'PlanSummary', criteria: criteria });
                });
            },

            updateFilters: function (criteria, fullReload) {
                WhistleOut.startProgress('#search-results-partial', 0.1, 50);

                var queryString = '?';
                if (fullReload) {
                    criteria.hideEmptyTabs = false;
                    criteria.showAll = false;
                    criteria.showRowFilters = true;
                    criteria.hideWidenResults = false;
                    criteria.hideShare = false;
                    criteria.hideCoverage = false;
                    criteria.hideCoverageStrip = false;
                    criteria.maxResults = null;
                    criteria.includefeatured = true;
                    WhistleOut.getCurrentLocation(
                        function (e) {
                            var address = e.label;
                            if (address.length > 1) {
                                criteria.address = address;
                            }
                            queryString += WhistleOut.MobilePhones.generateQueryString(criteria);
                            location.href = criteria.searchUrl + queryString;
                        },
                        function () {
                            queryString += WhistleOut.MobilePhones.generateQueryString(criteria);
                            location.href = criteria.searchUrl + queryString;
                        }
                    );

                    return;
                }
                queryString += WhistleOut.MobilePhones.generateQueryString(criteria);

                var resultsUrl = criteria.lines.length > 1 ? criteria.multiLineAjaxUrl : criteria.singleLineAjaxUrl;
                resultsUrl += queryString;

                wo$.ajax({
                    url: resultsUrl,
                    type: 'GET',
                    success: function (result) {
                        var $results = wo$('#search-results-partial');
                        $results.html(result);
                        WhistleOut.applyPopover($results);
                        WhistleOut.endProgress();
                        WhistleOut.notifications.fire('SearchResultsRendered');
                        wo$(window).resize();
                    },
                    error: function () {
                        WhistleOut.endProgress();
                    }
                });
            },

            setQueryString: function (queryString) {
                if (queryString.indexOf('?') === 0) {
                    queryString = queryString.substring(1);
                }

                var currentUrl = document.location.toString();
                var url;
                if (currentUrl.indexOf('?') >= 0) {
                    url = currentUrl.substring(0, currentUrl.indexOf('?') + 1) + queryString;
                } else {
                    url = currentUrl + '?' + queryString;
                }

                phoneController.HistoryWrapper.pushState(null, document.title, url);
            },

            initHistoryTracker: function () {
                WhistleOut.initHistoryTracker(phoneController);
            },

            fixArticleImage: function ($image) {
                if ($image.width() === 700) {
                    $image.addClass('fullwidth-image');
                }
            }
        };

        phoneController.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
